import { render, staticRenderFns } from "./Richlist.vue?vue&type=template&id=5390fcd6&scoped=true"
import script from "./Richlist.vue?vue&type=script&lang=js"
export * from "./Richlist.vue?vue&type=script&lang=js"
import style0 from "./Richlist.vue?vue&type=style&index=0&id=5390fcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390fcd6",
  null
  
)

export default component.exports